<template>
  <div ref="feed">
    <div v-if="!storeState.blocks.length === 0">
      <div class="nosource-container">
        <div class="nosource">
          <h4>
            <button @click="focusSource" class="btn-link"> Select</button> 
            a source or <button @click="storeState.addingSource = true" class="btn-link"> add a new one.</button>
          </h4>
        </div>
      </div>
    </div>
    <div v-else-if="!storeState.gotBlocks" class="tw-flex tw-justify-center">
      <div class="tw-pt-32">
        <v-progress-circular
          indeterminate
          :size="100"
          :width="8"
          color="primary"
        >
        </v-progress-circular>
      </div>
    </div>
    <!-- MAIN CONTAINER -->
    <div v-else class="tw-h-screen"> 
      <!-- LEFT SIDEBAR -->
      <!-- <div class="tw-bg-gray-200 tw-pt-2 tw-col-span-2">-->
      <div 
        class="tw-pt-4 tw-bg-gray-200 tw-fixed tw-h-full tw-left-0 tw-top-0 tw-w-1/6 tw-overflow-auto"
        style="box-shadow: inset 0 1px 30px 0 rgba(0,0,0,0.16) !important;"
      >
        <div> 
          <!-- categories -->
          <div
            v-for="(blockFilter, index) in blockFilters"
            :key="blockFilter.name"
            :class="{
              'hover:tw-bg-gray-300': true,
              'hover:tw-border-left-solid': true,
              'tw-font-bold': (blockFilter.name === blockCategoryFilter.name),
              'tw-p-1': true,
              'tw-rounded': true,
              'tw-cursor-pointer': true,
              }"
            @click="filterByCategory(blockFilter)"
          >
            <div class="tw-pl-4 tw-py-1">
            <!-- <v-icon small class="">{{blockFilter.icon}}</v-icon> -->
             {{blockFilter.name}}
            </div>
          </div>
          <!-- AUTHOR / OWNER -->
          <div class="tw-pt-8 tw-pb-0">
            <div class="tw-font-bold tw-pl-5 tw-p-1">
              Author
              <div class="tw-float-right tw-mb-0 tw-pr-2 tw-pt-1 tw-cursor-pointer" @click="sendInvite">
                <v-tooltip right dark color="#333">
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z" fill="#4A5568"/>
                      </svg>
                    </span>
                  </template>
                  <span class="tooltip-text">Invite people</span>
                </v-tooltip>
              </div>
            </div>
            <!-- {{storeState.tagList}} -->
            <div v-if="storeState.authorList.length > 0">
              <div
                v-for="(author, index) in storeState.authorList"
                :key="author.value"
                class="hover:tw-bg-gray-300 hover:tw-border-left-solid tw-pl-5 tw-p-1 tw-rounded tw-cursor-pointer"
                @click="filterByAuthor(author)"
              >
                {{getUserNickname(author.text)}}
                <!-- <div class="tw-float-right tw-pr-2">{{author.ct}}</div> -->
              </div>
            </div> 
          </div>
          <div class="tw-pl-5 tw-p-8">
            <div @click="goToHome" class="tw-cursor-pointer tw-font-bold">
              Back home
            </div> 
          </div>
          <!-- tags -->
        </div>
      </div>
      <!-- BLOCK LIST blocklist -->
      <div 
        class="tw-pt-4 tw-w-5/6 tw-fixed tw-top-0 tw-bottom-0 tw-overflow-auto" 
        style="left: 16.666667% !important;"
      >
        <!-- SEARCH & BUTTON -->
        <div class="tw-flex">
          <!-- search -->
          <div class="tw-flex-grow tw-mr-4 tw-ml-4">
            <textarea 
              ref="blockSearch"
              class="tw-w-full tw-text-xl" 
              v-model="searchTerm" 
              rows="1"
              placeholder="Search"
              v-on:keyup="searchKeyDown"
            >
            </textarea>
          </div>
          <!-- buttons -->
          <div class="tw-flex-none">
            <v-tooltip left dark color="#333">
              <template v-slot:activator="{ on }">
                <span v-on="on" class="tw-mr-3">
                  <v-btn icon @click="openCmdKBlank">
                    <v-icon>
                      mdi-dots-horizontal
                    </v-icon>
                  </v-btn>
                </span>
              </template>
              <span class="tooltip-text">Commands</span>
              <span class="key">
                <span v-if="storeState.isMac" class="key-inner key-inner-icon">
                  <v-icon color="#fff !important" size="12">mdi-apple-keyboard-command</v-icon>
                </span>
                <span v-else class="key-inner">
                  Ctrl
                </span>
              </span>
              <span class="key">
                <span class="key-inner">K</span>
              </span>
            </v-tooltip>
            <div @mouseenter="showAddMenu = true"
                @mouseleave="showAddMenu = false" class="tw-inline-block tw-mr-3">
              <div 
                
                class="tw-relative tw-inline-block tw-text-left"
              >
                <div>
                  <button class="tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z" fill="#4A5568"></path>
                    </svg>
                  </button>
                </div>

                <!--
                  Dropdown panel, show/hide based on dropdown state.

                  Entering: "transition ease-out duration-100"
                    From: "transform opacity-0 scale-95"
                    To: "transform opacity-100 scale-100"
                  Leaving: "transition ease-in duration-75"
                    From: "transform opacity-100 scale-100"
                    To: "transform opacity-0 scale-95"
                -->
                <div v-if="showAddMenu" class="tw-origin-top-right tw-absolute tw-right-0 tw-pt-2 tw-w-48 tw-rounded-md tw-shadow-lg tw-z-10 tw--mr-1">
                  <div class="tw-rounded-md tw-bg-white tw-shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                    <div class="tw-py-1">
                      <v-tooltip right dark color="#333">
                        <template v-slot:activator="{ on }">
                          <a v-on="on" @click="newBlock" class="tw-cursor-pointer tw-text-black tw-group tw-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-leading-5 hover:tw-bg-gray-200" role="menuitem">
                            <svg class="tw-mr-3 tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z"></path>
                            </svg>
                            New SQL
                          </a>
                        </template>
                        <span class="tooltip-text">New SQL</span>
                        <span class="key">
                          <span class="key-inner">
                            C
                          </span>
                        </span>
                      </v-tooltip>
                      <a @click="createStory" class="tw-cursor-pointer tw-text-black tw-group tw-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-leading-5 hover:tw-bg-gray-200" role="menuitem">
                        <svg class="tw-mr-3 tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"></path>
                          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd"></path>
                        </svg>
                        New Story
                      </a>
                      <a @click="createDashboard" class="tw-cursor-pointer tw-text-black tw-group tw-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-leading-5 hover:tw-bg-gray-200" role="menuitem">
                        <svg class="tw-mr-3 tw-h-5 tw-w-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                          <path d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                          </path>
                        </svg>
                        New Dashboard
                      </a>
                    </div>
                    <div class="tw-border-t tw-border-gray-100"></div>
                  </div>
                </div>
              </div>
              <!-- <v-menu
                v-model="newThing"
                :open-on-hover="true"
                :offset-y="true"
                :offset-x="false"
                origin="center center"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="newBlock" v-on="on">
                    <v-icon>
                      mdi-plus-circle
                    </v-icon>
                  </v-btn>
                </template>
                <v-list class="">
                  <v-list-item class="tw-cursor-pointer" @click="newBlock">
                    <div>
                      <v-icon>mdi-run</v-icon>
                      <span class="pad-span-left">Run SQL</span>
                    </div>
                  </v-list-item>
                  <v-list-item class="tw-cursor-pointer" @click="createStory">
                    <div>
                      <v-icon>mdi-file-document-box-plus-outline</v-icon>
                      <span class="pad-span-left">Create Story</span>
                    </div>
                  </v-list-item>
                </v-list>
              </v-menu> -->
            </div>
            <div class="tw-inline-block tw-mr-1 tw-ml-2">
              <button @click="refreshFeed({rows: 500})" class="tw-mt-2 tw-mr-6 tw-float-right tw-flex tw-items-center tw-text-gray-400 hover:tw-text-gray-600 focus:tw-outline-none focus:tw-text-gray-600" aria-label="Options" id="options-menu" aria-haspopup="true" aria-expanded="true">
                <svg width="18" height="18" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="#4A5568">
                  <path 
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <!-- BLOCKS -->
        <div class="tw-mx-4 tw-mt-2 tw-font-bold" v-if="!storeState.gotFeed">
          Getting feed...
        </div>
        <div class="tw-mx-4 tw-mt-2" v-else-if="storeState.gotFeed && storeState.feedResults.length === 0">
          No activity, <a @click="newBlock">create a new block</a> or 
          <a @click="refreshFeed({rows: 500})">refresh the feed</a>
        </div>
        <div v-else>
          <div class="tw-flow-root">
            <ul class="tw-mt-2 tw-list-none">
              <li @mouseover="hoveringRow = index" v-for="(row, index) in storeState.feedResults" :key="index" 
                class="hover:tw-bg-gray-200 tw-px-4 tw-pb-4">
                <div class="tw-relative tw-pt-6">
                  <span class="tw-absolute tw-top-4 tw-left-4 tw--ml-px tw-h-full tw-w-0.5 tw-bg-gray-200" aria-hidden="true"></span>
                  <div class="tw-relative tw-flex tw-space-x-3">
                    <div class="tw-pt-1">
                      <span 
                        class="tw-h-8 tw-w-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-ring-8 tw-ring-white"
                        :class="{
                          'tw-bg-red-400': getFeedIconColor(row) === 'red',
                          'tw-bg-green-400': getFeedIconColor(row) === 'green',
                          }"
                      >
                        <!-- Heroicon name: user -->
                        <span v-html="getFeedIcon(row)"></span>
                      </span>
                    </div>
                    <div class="tw-min-w-0 tw-flex-1 tw-flex tw-justify-between tw-space-x-4">
                      <div>
                        <p class="tw-text-sm tw-text-gray-500">
                          <span class="tw-font-medium tw-text-gray-900">{{getTitle(row)}}</span> 
                          by {{ getUserNickname(row.email) }}
                        </p>
                        <p class="tw-font-medium tw-text-gray-500 tw-text-sm">
                          {{lineTwo(row)}}
                          {{getErrorMessage(row)}}
                          <!-- {{row}} -->
                        </p>
                        
                      </div>
                      
                      <div class="tw-text-right tw-text-sm tw-whitespace-nowrap tw-text-gray-500 tw-pt-1">
                        <span>
                          {{feedFromNow(row.created_on)}}
                          <!-- {{row.created_on}} -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tw-ml-10" v-if="row.event && row.event.startsWith('application run')">
                  <div :class="{'tw-hidden': index != hoveringRow}" class="tw-font-bold tw-text-sm tw-text-gray-900">
                    <div @click="goToBlock(row)" class="tw-inline-block hover:tw-text-gray-600 tw-cursor-pointer tw-mr-4">
                      Open block
                    </div>
                    <div @click="filterForThisRow(row)" class="tw-inline-block hover:tw-text-gray-600 tw-cursor-pointer">
                      Filter for this block
                    </div>
                  </div>
                  <div :class="{'tw-hidden': index != hoveringRow}">
                    {{lineThree(row)}}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';


export default {
  mounted() {
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    });
    if (this.storeState.gotFeed) this.filterFeed()
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      loading: false,
      hoveringRow: -1,
      searchTerm: '',
      blockAuthorCounts: store.state.blockAuthorCounts,
      showAddMenu: false,
      blockFilters: [
        {
          name: 'All',
          icon: 'mdi-save'
        },
        {
          name: 'Errors',
          icon: 'mdi-save'
        },
        {
          name: 'Scheduled',
          icon: 'mdi-update'
        },
        {
          name: 'Manual',
          icon: 'mdi-star'
        },
      ],
      blockCategoryFilter: {
        name: 'All',
        icon: 'mdi-save'
      },
      viewingHistory: false,
      numOfTagsToShow: 8,
      hoveringBlock: false,
      hoveredBlock: {},
      blockHoverIndex: -1,
      newThing: false,
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      setsOnly: false,
      docsOnly: false,
      storiesOnly: false,
      saved: false,
      blockList: [],
      blockCategories: [
        {id: 0, name: 'Home', show: true, f: function(self) {
          console.log('Home...')
          self.favorites = true
          self.scheduled = true
          self.saved = true
          self.setsOnly = false
          self.storiesOnly = false
          self.docsOnly = false
          }
        },
        // {id: 1, name: 'Saved', f: function(self) {
        //   console.log('Saved...')
        //   self.favorites = false
        //   self.scheduled = false
        //   self.saved = true
        //   self.setsOnly = false
        //   self.storiesOnly = false
        //   self.docsOnly = false
        //   // this.$forceUpdate()
        //   }
        // },
        {id: 2, name: 'Scheduled', show: true, f: function(self) {
          console.log('favorites...')
          self.favorites = false
          self.saved = false
          self.scheduled = true
          self.setsOnly = false
          self.storiesOnly = false
          self.docsOnly = false
          // this.$forceUpdate()
          }
        },
        {id: 3, name: 'Favorites', show: true, f: function(self) {
          console.log('favorites...')
          self.scheduled = false
          self.saved = false
          self.favorites = true
          self.setsOnly = false
          self.storiesOnly = false
          self.docsOnly = false
          }
        },
        {id: 4, name: 'Sets', show: false, f: function(self) {
          console.log('sets...')
          self.favorites = false
          self.saved = false
          self.scheduled = false
          self.setsOnly = true
          self.storiesOnly = false
          self.docsOnly = false
          // this.$forceUpdate()
          }
        },
        {id: 5, name: 'Stories', show: true, f: function(self) {
          console.log('Stories...')
          self.favorites = false
          self.saved = false
          self.scheduled = false
          self.setsOnly = false
          self.storiesOnly = true
          self.docsOnly = false
          // this.$forceUpdate()
          }
        },
        {id: 6, name: 'Dashboards', show: false, f: function(self) {
          console.log('docs...')
          self.favorites = false
          self.saved = false
          self.scheduled = false
          self.setsOnly = false
          self.storiesOnly = false
          self.docsOnly = true
          // this.$forceUpdate()
          }
        },
        {id: 7, name: 'History', show: true, f: function(self) {
          console.log('History...')
          self.favorites = false
          self.scheduled = false
          self.saved = false
          self.setsOnly = false
          self.storiesOnly = false
          self.docsOnly = false
          // this.$forceUpdate()
          }
        },
      ],
      underlay: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
  },
  watch: {
    'storeState.gotFeed': {
      handler: function (val, oldVal) {
        this.filterFeed({})
      },
      deep: false,
    }
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    getParamsFromUrl() {
      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.blockId) {
          this.searchTerm = this.$route.query.blockId
        }
      }
    },
    getFeedIconColor(row) {
      try {
        var j = JSON.parse(row.properties)
      } catch (error) {
        return 'green'
      }
      if (row.event === 'application run error') {
        return 'red'
      }
      if (row.event === 'background job error') {
        return 'red'
      }
      if (j.errorMessage || j.failedRows) {
        return 'red'
      }
      return 'green'
    },
    getFeedIcon(row) {
      try {
        var j = JSON.parse(row.properties)
      } catch (error) {
        return store.getIcon('user', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (row.event === 'application run error') {
        return store.getIcon('x', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (j.errorMessage || j.failedRows) {
        return store.getIcon('x', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (j.platform === 'scheduler') {
        return store.getIcon('check', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (j.platform === 'background job complete') {
        return store.getIcon('check', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (row.event === 'background job error') {
        return store.getIcon('x', 'tw-h-5 tw-w-5 tw-text-white')
      }
      if (row.event === 'application run success') {
        return store.getIcon('user', 'tw-h-5 tw-w-5 tw-text-white')
      }
      return store.getIcon('user', 'tw-h-5 tw-w-5 tw-text-white')
    },
    feedFromNow(dt) {
      return moment(dt).fromNow()
    },
    sendInvite() {
      this.storeState.cmdkParentCmd = 'sendInvite'
      this.storeState.cmdkInput = ''
      this.storeState.searchIndex = 0
      this.storeState.cmdkActive = true
    },
    hoverRow(row, index) {
      this.hoveringRow = index
      this.hoveredBlock = block
    },
    searchKeyDown(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.searchTerm, e)
      if ([13, 40, 38].includes(e.keyCode)) {
        e.preventDefault()
        console.log('hit enter, up, down...')
        return
      }
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
      // this.filterFeed(opts)
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var searchInLen = searchIn.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * (startMatch+1)) * 1.0 / searchInLen * 1.0
      return {include: include, matches: matches, ratio: ratio}
    },
    filterByCategory(filter) {
      console.log('filterFeedByCategory ', filter)
      this.blockCategoryFilter = filter
      this.viewingHistory = false
      if (filter.name === 'History') {
        this.viewingHistory = true
        this.blockCategoryFilter = false
      }
      this.searchTerm = ''
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
    },
    filterByPic(email) {
      this.blockCategoryFilter = false
      let a2 = this.getUserNickname(email)
      this.searchTerm = `@${a2.replace(/ /g, '_')}`
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
    },
    filterByAuthor(author) {
      this.blockCategoryFilter = false
      let a2 = this.getUserNickname(author.text)
      this.searchTerm = `@${a2.replace(/ /g, '_')}`
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
    },
    filterByTag(tag) {
      this.blockCategoryFilter = false
      this.searchTerm = `#${tag.text.replace(/ /g, '_')}`
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
    },
    getEventProperties(row) {
      try {
        return JSON.parse(row.properties)
      } catch (error) {
        return false
      }
    },
    getTitle(row) {
      let ep = this.getEventProperties(row)
      if (ep && ep.blockId && this.storeState.blocks[ep.blockId]) {
        let block = this.storeState.blocks[ep.blockId]
        if (row.event === 'application run error') return `${block.title} (error)`
        return `${block.title}`
      }
      return row.event
    },
    getErrorMessage(row) {
      let props = this.getEventProperties(row)
      if (props && props.failedRows) return props.failedRows
      if (props && props.errorMessage) return props.errorMessage
      if (props && props.errors) return JSON.stringify(props.errors)
      return ''
    },
    lineTwo(row) {
      let ep = this.getEventProperties(row)
      if (row.event === 'application run error' && ep.error) return ep.error.slice(0, 100)
      if (row.event === 'application run success' && ep.rowCount) {
        let secs = (ep.qRunDuration).toFixed(1)
        return `Executed ${ep.rowCount} rows in ${secs} seconds.`
      }
      if (row.event === 'background job completed') {
        try {
          let props = JSON.parse(row.properties)
          if (props.numberRecordsProcessed) {
            return `Background job complete (${props.numberRecordsProcessed - props.numberRecordsFailed} / ${props.numberRecordsProcessed}).`
          } else if (props.swChunk) {
            return `Background job complete, processed ${props.swChunk} chunks`
          } else {
            return `Background job complete`
          }
        } catch (error) {
          console.error('error', error)
          return `Background job complete.`  
        }
      }

      if (row.event === 'background job error') {
        try {
          let props = JSON.parse(row.properties)
          if (props.error) {
            return `${JSON.stringify(props.error)}`
          } else {
            return `Background job error`
          }
        } catch (error) {
          console.error('error', error)
          return `Background job error.`  
        }
      }
      
      // if (row.event === 'background job completed') {
      //   return `Background job complete.`
      // }
      if (row.event === 'application run success') return `Executed on time.`
      return ''
    },
    lineThree(row) {
      let ep = this.getEventProperties(row)
      if (row.event === 'application run error' && ep.error) return ep.error.slice(0, 255)
      return ''
    },
    filterFeed(opts) {
      if (!opts) opts = {}
      if (!opts.searchTerm) opts.searchTerm = this.searchTerm
      this.storeState.feedResults = []
      let searchTerms = opts.searchTerm.toLowerCase().split(' ').filter(t => t.length > 0)
      var tags = []
      var author = false
      for (let index = 0; index < searchTerms.length; index++) {
        const term = searchTerms[index];
        if (term.startsWith('#')) {
          var theseTags = store.findHashtags(term)
          if (theseTags.length > 0) tags = tags.concat(theseTags.map(t => t.replace('#', '').replace(/ /g, '_')))
        }
        if (term.startsWith('@')) {
          author = term
        }
      }
      for (let index = 0; index < this.storeState.feed.length; index++) {
        const f = this.storeState.feed[index];
        var addBlock = 0
        if (author && this.getUserNickname(f.email).startsWith(author.replace('@', ''))) {
          addBlock+=1
        }
        for (let index = 0; index < searchTerms.length; index++) {
          const term = searchTerms[index];
          let searchIn = JSON.stringify(f)
          // let match = this.everyLetterMatch(term, searchIn.toLowerCase())
          let match = searchIn.toLowerCase().includes(term)
          if (match) {
            addBlock+=1
          }
        }
        try {
          var eventProps = JSON.parse(f.properties)
        } catch (error) {
          var eventProps = {}
        }
        if (!eventProps.blockId) {
          // dont push
        } else if (this.blockCategoryFilter) {
          if (this.blockCategoryFilter.name === 'Errors' && f.event.includes('error') && addBlock - searchTerms.length >= 0) {
            this.storeState.feedResults.push(f)
          } else if (this.blockCategoryFilter.name === 'Scheduled' && eventProps.platform === 'scheduler' && addBlock - searchTerms.length >= 0) {
            this.storeState.feedResults.push(f)
          } else if (this.blockCategoryFilter.name === 'Manual' && eventProps.platform != 'scheduler' && addBlock - searchTerms.length >= 0) {
            this.storeState.feedResults.push(f)
          } else if (this.blockCategoryFilter.name === 'All' && addBlock - searchTerms.length >= 0) {
            this.storeState.feedResults.push(f)
          }
        } else if (addBlock - searchTerms.length >= 0) {
          this.storeState.feedResults.push(f)
        }
      }
      if (this.storeState.feedResults.length === 0) return
      this.storeState.feedResults.sort((a, b) => { return b.id - a.id;}) 
      this.storeState.feedResults = this.storeState.feedResults.slice(0, 100)
      this.$forceUpdate()
    },
    everyLetterMatch(searchTerm, searchIn) {
      searchTerm = searchTerm.toLowerCase()
      var include = true
      var searchTermLen = searchTerm.length
      var matches = 0
      var startMatch = searchIn.startsWith(searchTerm)
      for (let i = 0; i < searchTerm.length; i++) {
          if (!searchIn.includes(searchTerm[i].toLowerCase())) {
            include = false
            break
          } else {
            matches++
            //this chops off where the last letter was found, this means search letters need to be 
            //the same order as the match, e.g. segev = segment.events, but segev != vesg
            searchIn = searchIn.slice(searchIn.indexOf(searchTerm[i].toLowerCase()))
          }
      }
      var ratio = (matches * startMatch) * 1.0 / searchTermLen
      return {include: include, matches: matches, ratio: ratio}
    },
    createDashboard(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Docs', params: {id: blockId, cellType: 'doc' }}).catch(err => console.error(err))
      let self = this
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault()
    },
    createStory(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Run', params: {id: blockId, cellType: 'story' }}).catch(err => console.error(err))
      let self = this
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault()
    },
    getScheduleError(uuid) {
      let schedule = this.storeState.schedules[uuid]
      if (schedule && schedule.status === 'error') return true
      return false
    },
    getScheduleErrorDetails(uuid) {
      let schedule = this.storeState.schedules[uuid]
      if (schedule && schedule.status === 'error') return schedule.error
      return false
    },
    getScheduleDetails(uuid) {
      let schedule = this.storeState.schedules[uuid]
      if (!schedule) return 'not run yet'
      if (schedule.status === 'error') return 'error in update'
      return `updated ${moment(schedule.last_run_dt).fromNow()}`
    },
    getSqlTables(ast) {
      if (!ast) return ''
      if (ast.tables && ast.tables.length > 0) {
        var ret = ''
        for (let index = 0; index < ast.tables.length; index++) {
          const element = ast.tables[index];
          if (element.type != 'table') continue
          if (element.parent) {
            ret += `${element.parent}.${element.real_name}`
          } else if (element.real_name) {
            ret += element.real_name
          }
          if (index < ast.tables.length - 1) {
            ret += ', '
          }
        }
        return ret
      }
      return ''
    },
    showSearch() {
      this.storeState.searching = true
      this.$router.push({ name: 'Search'}).catch(err => console.error(err))
      // setTimeout(() => {
      //   this.$refs.searchText.focus()
      // }, 0);
    },
    goToHome(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
      if (e && e.preventDefault) e.preventDefault()
    },
    goToSets(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Sets', params: {id: blockId }}).catch(err => console.error(err))
      let self = this
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault()
    },
    newDoc(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      this.$router.push({ name: 'Docs', params: {id: blockId }}).catch(err => console.error(err))
      let self = this
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault()
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    getUserNickname(email) {
      if (email) return email.split('@')[0]
      return this.storeState.settings.user.me.email.split('@')[0]
    },
    fromNowRunFormat: function (data) {
      if (!data || !data.viewedOn) return 'Never run'
      return moment(data.viewedOn/1000).fromNow()
    },
    deleteBlock(block) {
      Vue.delete(this.storeState.blocks, block.uuid)
      store.deleteBlock(block)
      this.hoveringBlock = false
      this.hoveredBlock = {}
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    goToBlock(row) {
      try {
        var eventProps = JSON.parse(row.properties)
      } catch (error) {
        return
      }
      this.$parent.openBlock(eventProps.blockId)
    },
    refreshFeed(opts) {
      this.searchTerm = ''
      this.storeState.gotFeed = false
      this.$parent.getSoupFeed(opts)
    },
    filterForThisRow(row) {
      try {
        var eventProps = JSON.parse(row.properties)
      } catch (error) {
        return
      }
      this.searchTerm = eventProps.blockId
      this.storeState.gotFeed = false
      //get
      this.$parent.getSoupFeed({blockId: eventProps.blockId})
      this.filterFeed({})
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      if (e.currentTarget.dataset.uuid) {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        let blockId = e.currentTarget.dataset.uuid
        let block = this.storeState.blocks[blockId]
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    openCmdKBlank() {
      this.$parent.openCmdK({})
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newWindow(blockId) {
      if (!blockId) {
        blockId = store.uuidv4()
        this.storeState.newBlocks.push(blockId)
        store.saveToLocalStorage('seekwell_newBlockId', blockId)
      }
      let routeData = this.$router.resolve({ name: 'Run', params: {id:  blockId}});
      window.open(routeData.href, '_blank');
      this.storeState.cmdkActive = false
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      let curPath = this.$route.path;
      if (curPath.startsWith('/blocks') || curPath === '/') {
        if (this.storeState.activeQueue === 5) {
          this.$router.push({ name: 'Stories', params: {id:  blockId}}).catch(err => console.error(err))
          return
        }
      }
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.searchTerm, e)
      if ([13, 40, 38].includes(e.keyCode)) {
        e.preventDefault()
        console.log('hit enter, up, down...')
        return
      }
      let opts = {searchTerm: this.searchTerm}
      this.filterFeed(opts)
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
    getBlockList() {
      if (Object.keys(this.storeState.blocks).length === 0) return
      // if (this.storeState.searching) {
      //   // let blocks = Object.keys(this.storeState.searchResults).map(id => this.storeState.blocks[id])
      //   // blocks.sort((a, b) => { return b.viewedOn - a.viewedOn;})
      //   return this.searchResults
      // }
      this.blockList = []
      for (let [key, obj] of Object.entries(this.storeState.blocks)) {
        if (obj.cellType != 'json' && obj.cellType != 'snippet') {
          if ((obj.cellType === 'sql' && obj.code.length > 0) || obj.cellType != 'sql') {
            this.blockList.push(obj)
          }
        }
      }
      if (this.blockList.length === 0) {
        this.storeState.noBlocks = true
      } else {
        this.storeState.noBlocks = false
      }
      this.blockList.sort((a, b) => { return b.viewedOn - a.viewedOn;})
      // let blockCat = this.blockCategories.find(q => q.id === Number(this.storeState.activeQueue))
      // if (blockCat.name === 'Home') {
      //   this.blockList = this.blockList.filter(b => b.favorite || b.repeat.period || b.title.length > 0)
      // } else if (this.favorites) {
      //   console.log('only favs')
      //   this.blockList = this.blockList.filter(b => b.favorite)
      // } else if (this.scheduled) {
      //   this.blockList = this.blockList.filter(b => b.repeat.period)
      // } else if (this.saved) {
      //   this.blockList = this.blockList.filter(b => b.title.length > 0)
      // } else if (this.setsOnly) {
      //   this.blockList = this.blockList.filter(b => b.set && b.set.type === 'explore')
      // } else if (this.storiesOnly) {
      //   this.blockList = this.blockList.filter(b => b.cellType === 'story')
      // } else if (this.docsOnly) {
      //   this.blockList = this.blockList.filter(b => b.cellType === 'doc')
      // }
      this.storeState.feedResults = this.blockList.slice(0, 100)
    }
  },
  computed: {
  },
  created() {
    // this.filterFeed({searchTerm: ''})
    this.getParamsFromUrl()
    this.filterFeed = debounce(this.filterFeed, 500)
    // this.blockCategories.find(q => q.id === Number(this.storeState.activeQueue)).f(this)
    // this.getBlockList()
    // this.storeState.viewNumber = 1
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.save-search-q2 {
  float: right;
  margin-top: -35px;
  margin-right: 2rem;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}

.search-container {
  padding-top: 60px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
</style>
